<template>
  <div class="faq-container">
    <iframe
      :src="faqUrl"
      frameborder="0"
      class="faq-iframe"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "FAQ",
  computed: {
    faqUrl() {
      const locale = this.$i18n.locale;
      if (locale === 'ja' || locale === 'jp') {
        return '/faq_ja.html';
      }
      return '/faq.html';
    }
  }
};
</script>

<style lang="scss" scoped>
.faq-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.faq-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
